import Vue from 'vue'
import App from './App.vue'

import { defineCustomElements } from 'hrvcomponents/dist/loader'; 

Vue.config.productionTip = false

// tell Vue to ignore all components defined in the hrvcomponents
// package.
//
Vue.config.ignoredElements = [/breath-\w*/]; 

// Bind the custom elements to the window object
defineCustomElements(window); 

new Vue({
  render: h => h(App)
}).$mount('#app')
